const Category = Object.freeze({
  AUTHORS: 'Authors',
  BENCHMARK_EMOJI: 'BenchmarkEmoji',
  BENCHMARK_AGE: 'BenchmarkAge',
  BENCHMARK_BRANDS: 'BenchmarkBrands',
  BENCHMARK_ETHNICITY: 'BenchmarkEthnicity',
  BENCHMARK_GENDER: 'BenchmarkGender',
  BENCHMARK_HASHTAGS: 'BenchmarkHashtags',
  BENCHMARK_INTERESTS: 'BenchmarkInterests',
  BENCHMARK_PEOPLE: 'BenchmarkPeople',
  BENCHMARK_PHRASES: 'BenchmarkPhrases',
  BENCHMARK_BIO_TEXT: 'BenchmarkBioText',
  BENCHMARK_PROFESSIONS: 'BenchmarkProfessions',
  BENCHMARK_THINGS: 'BenchmarkThings',
  DISLIKES: 'Dislikes',
  DOMAINS: 'Domains',
  EMOJI: 'Emoji',
  FAN_ENGAGEMENTS: 'FanEngagements',
  GENDER: 'Gender',
  GEOLOCATION: 'Geolocation',
  HASHTAGS: 'Hashtags',
  LANGUAGE: 'Language',
  LIKES: 'Likes',
  NEGATIVE_BEHAVIORS: 'NegativeBehaviors',
  NEGATIVE_EMOTIONS: 'NegativeEmotions',
  NEGATIVE_EMOTIONS_BEHAVIORS_TO_THINGS: 'NegativeEmotionsBehaviorsToThings',
  ORG_PRODUCTS: 'OrgProducts',
  PEOPLE: 'People',
  PRODUCT_NAME: 'ProductName',
  PHRASES: 'Phrases',
  POSITIVE_BEHAVIORS: 'PositiveBehaviors',
  POSITIVE_EMOTIONS: 'PositiveEmotions',
  POSITIVE_EMOTIONS_BEHAVIORS_TO_THINGS: 'PositiveEmotionsBehaviorsToThings',
  SENTIMENT: 'Sentiment',
  SOURCES: 'Sources',
  THINGS: 'Things',
  THINGS_TO_NEGATIVE_EMOTIONS_BEHAVIORS: 'ThingsToNegativeEmotionsBehaviors',
  THINGS_TO_POSITIVE_EMOTIONS_BEHAVIORS: 'ThingsToPositiveEmotionsBehaviors',
  TRENDING_THINGS: 'TrendingThings',
  TRENDING_TERMS: 'TrendingTerms',
  TRENDING_HASHTAGS: 'TrendingHashtags',
  TRENDING_BRANDS: 'TrendingBrands',
  TRENDING_PEOPLE: 'TrendingPeople',
  TRENDING_EMOJI: 'TrendingEmoji',
  POST_ACTIVITY_DAY_OF_WEEK: 'PostActivityDayOfWeek',
  POST_ACTIVITY_HOUR_OF_DAY: 'PostActivityHourOfDay',
  POST_ACTIVITY_HOUR_OF_WEEK: 'PostActivityHourOfWeek',
  LANGUAGES_ANALYSIS: 'LanguagesAnalysis',
  TAGS: 'Tags',
  DOC_HIERARCHY: 'DocHierarchy',
  MEASUREMENTS: 'Measurements',
  CHANNELS_METRICS: 'ChannelsMetrics',
  STAR_RATING: 'StarRating',
  SURVEY_SCORE: 'SurveyScore',
  LOGOS: 'Logos',
  DETECT_OBJECTS: 'DetectObjects',
  DETECT_SCENES: 'DetectScenes',
  DETECT_EMOTIONS: 'DetectEmotions',
  SOCIAL_MOOD: 'SocialMood',
  TIMELINE_SOCIAL_MOOD: 'TimelineSocialMood',
  SUB_REDDITS: 'SubReddits'
})
export default Category
export type CategoryStrings = typeof Category[keyof typeof Category]
// RESERVE BELOW
